/**
 * Swiss Forest Lab Tags for filtering metadatas.
 *
 * @summary Swiss Forest Lab tags
 * @author Dominik Haas-Artho
 *
 * Created at     : 2019-10-23 16:34:51
 * Last modified  : 2019-10-30 15:38:12
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
export const ednaTag = { name: 'EDNA', enabled: false };

/*
export const swissFLExtraTags = [
  { name: 'INFRASTRUCTURE', enabled: true, color: '#ede7f6' },
  { name: 'MODEL', enabled: true, color: '#fbe9e7' },
];
*/
